// View-only list of an athlete's workout items for the sidebar "phone" preview.
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import CalendarWorkoutListItem from './CalendarWorkoutListItem';

const ListWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  flex: 1;
  margin-top: 20px;
`;

const BreakHeader = styled('div')`
  font-family: 'Nunito Sans';
  font-weight: 700;
  font-size: 13px;
  color: #444444;
  margin-top: 6px;
`;

const CalendarWorkoutPreviewList = ({ renderedItems, onSelectExercise }) => (
  <ListWrapper>
    {renderedItems.map((entry, idx) => {
      if (entry.kind === 'break') {
        // eslint-disable-next-line react/no-array-index-key
        return <BreakHeader key={`break-${idx}`}>{entry.item.title}</BreakHeader>;
      }
      const nextEntry = renderedItems[idx + 1];
      return (
        <CalendarWorkoutListItem
          key={entry.item.assignedId || entry.item.saveDataId || entry.flatIndex}
          workoutItem={entry.item}
          showVerticalLine={!!nextEntry && nextEntry.kind === 'exercise'}
          onSelect={() => onSelectExercise(entry.flatIndex)}
        />
      );
    })}
  </ListWrapper>
);

CalendarWorkoutPreviewList.propTypes = {
  renderedItems: PropTypes.arrayOf(PropTypes.shape({
    kind: PropTypes.string,
    item: PropTypes.instanceOf(Object),
    flatIndex: PropTypes.number,
  })).isRequired,
  onSelectExercise: PropTypes.func.isRequired,
};

export default CalendarWorkoutPreviewList;
